import React from "react";
import { Helmet } from "react-helmet";
import { seoData } from "../constants/constant";

export const SEOPage = (props) => {
  const { page } = props;
  const getSeoData = (pageName) =>
    seoData.find((pageItem) => pageItem.page === pageName);
  const data = getSeoData(page);
  const {
    title = "Dec-Tec",
    description = "Dec-Tec: Waterproofing Solution for Balconies, Walkways & More",
    keywords = "",
    url = "https://dec-tec.com",
  } = data || {};
  const image =
    "https://dectecstorageprod.blob.core.windows.net/website/images/logo/dectec-logo-header.png";
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      <meta name="author" content="Dec-Tec" />

      {/* Open Graph (Facebook) Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content="Dec-Tec" />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <meta name="robots" content="index, follow" />
    </Helmet>
  );
};
